/* eslint-disable import/no-anonymous-default-export */
const getMessage = (res, options) => {
  if (res?.status !== 200) return res?.statusText
  return `Service error | ${options.url}`
}

export default (res, options) => {
  throw Object({
    type: 'ERROR',
    message: getMessage(res, options)
  })
}
